<template>
    <div></div>
</template>

<script>
    export default {
        name: "SetLanguage",
        props: {
            lang: {
                required: true,
                type: String,
            }
        },
        created () {
            this.$store.commit('setLanguage', this.lang);
            this.$router.push({ name: 'home' });
        }
    }
</script>

<style scoped>

</style>